import type { ReactNode } from "react";

import "./ui.css";

type AlertTone = "info" | "success" | "warning" | "danger";

interface AlertProps {
  tone?: AlertTone;
  title?: ReactNode;
  children?: ReactNode;
}

export function Alert({ tone = "info", title, children }: AlertProps) {
  return (
    <div className={`alert alert--${tone}`} role="alert">
      {title && <div className="alert__title">{title}</div>}
      {children && <div className="alert__body">{children}</div>}
    </div>
  );
}
